import React, { useMemo } from "react";

import { usePersistState } from "@/hooks/usePersistState";
import { SupAlertBar } from "@repo/core-ui";
import { SupAlert, SupInfoCircle } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

export type AlertBarStylingType = "error" | "info" | "warning" | "default";

interface LayoutAlertBarMessageProps {
  message: string;
  type?: AlertBarStylingType;
}

export default function LayoutAlertBarMessage({ message, type = "default" }: LayoutAlertBarMessageProps) {
  const [displayMessage, setDisplayMessage] = usePersistState<string>(`app-alert-seen`, "");

  const color = type !== "default" ? type : "warning";

  const icon = ["default", "info"].includes(type) ? <SupInfoCircle /> : <SupAlert />;

  const isVisible = useMemo(() => message !== displayMessage, [displayMessage, message]);

  return (
    <SupAlertBar
      visible={isVisible}
      closeable={type === "default"}
      onClose={() => setDisplayMessage(message)}
      content={message}
      icon={icon}
      color={color}
      className={twMerge("min-h-[60px] md:min-h-[40px]", type === "default" && "bg-primary-200 pl-8 text-neutral-900")}
    />
  );
}
